module.exports = __webpack_public_path__ + "static/item-9-8d7e0ba234b8e7189d2dd0ed73695859.png";